import merchantConfig from '@/view/payAgr/merchantConfig/index.vue'
import merchantConfigCreate from '@/view/payAgr/merchantConfig/create.vue'
import merchantConfigDetail from '@/view/payAgr/merchantConfig/detail.vue'
import payAgrOrder from '@/view/payAgr/order/index.vue'
import payAgrOrderCreate from '@/view/payAgr/order/create.vue'
import payAgrOrderDetail from '@/view/payAgr/order/detail.vue'
import payAgrRetry from '@/view/payAgr/retry/index.vue'
import payAgrMerchantStat from '@/view/payAgr/merchantStat/index.vue'

export default [
    {path: '/pay-agr/merchantConfig', name: 'payAgrMerchantConfig', component: merchantConfig, meta: '商户协议配置'},
    {path: '/pay-agr/merchantConfig/create', name: 'payAgrMerchantConfigCreate', component: merchantConfigCreate, meta: '新增/编辑商户协议配置'},
    {path: '/pay-agr/merchantConfig/detail', name: 'payAgrMerchantConfigDetail', component: merchantConfigDetail, meta: '商户协议配置详情'},
    {path: '/pay-agr/order', name: 'payAgrOrder', component: payAgrOrder, meta: '支付订单'},
    {path: '/pay-agr/order/create', name: 'payAgrOrderCreate', component: payAgrOrderCreate, meta: '创建支付订单'},
    {path: '/pay-agr/order/detail', name: 'payAgrOrderDetail', component: payAgrOrderDetail, meta: '支付订单详情'},
    {path: '/pay-agr/retry', name: 'payAgrRetry', component: payAgrRetry, meta: '重试管理'},
    {path: '/pay-agr/merchantStat', name: 'payAgrMerchantStat', component: payAgrMerchantStat, meta: '支付协议统计'},
]
